import { gpCommon } from '../../app';
import passwordInputTemplate from './password-input.html';

export class PasswordInputComponent {
    password: string | null = null;
    name: string | null = null;
    autocomplete: string | null = null;
    label: string | null = null;
    placeholder: string | null = null;
    validationText: string | null = null;
    passwordVisible = false;

    constructor() { }


    public togglePassword() {
        this.passwordVisible = !this.passwordVisible;
    }
}


gpCommon.component('gpPasswordInput', {
    template: passwordInputTemplate,
    controller: PasswordInputComponent,
    bindings: {
        name: '@',
        autocomplete: '@?',
        label: '@?',
        placeholder: '@?',
        password: '=',
        validationText: '@?'
    }
});
